<template>
  <div class="admin-container">
    <aside class="sidebar">
      <h2>后台管理</h2>
      <nav>
        <a 
          v-for="item in menuItems" 
          :key="item.key"
          :class="{ active: activeMenu === item.key }"
          @click="activeMenu = item.key"
        >{{ item.label }}</a>
      </nav>
      <div class="back-home">
        <router-link to="/">返回首页</router-link>
      </div>
    </aside>
    
    <main class="main-content">
      <!-- 企业介绍管理 -->
      <div v-if="activeMenu === 'about'" class="panel">
        <div class="panel-header">
          <h3>企业介绍管理</h3>
        </div>
        <form @submit.prevent="submitAboutForm" class="about-form">
          <div class="form-group">
            <label>页面标题</label>
            <input v-model="aboutFormData.title" required>
          </div>
          <div class="form-group">
            <label>副标题</label>
            <input v-model="aboutFormData.subtitle" required>
          </div>
          <div class="form-group">
            <label>内容标题</label>
            <input v-model="aboutFormData.contentTitle" required>
          </div>
          <div class="form-group">
            <label>企业图片</label>
            <input type="file" @change="handleAboutImageChange" accept="image/*">
            <img v-if="aboutFormData.image" :src="aboutFormData.image" class="preview-img">
          </div>
          <div class="form-group">
            <label>第一段内容</label>
            <textarea v-model="aboutFormData.paragraphs[0]" required></textarea>
          </div>
          <div class="form-group">
            <label>第二段内容</label>
            <textarea v-model="aboutFormData.paragraphs[1]" required></textarea>
          </div>
          <div class="stats-section">
            <h4>数据统计</h4>
            <div v-for="(stat, idx) in aboutFormData.stats" :key="idx" class="stat-item">
              <div class="form-group">
                <label>数据{{ idx + 1 }} - 数值</label>
                <input v-model="stat.number" placeholder="如：15000+">
              </div>
              <div class="form-group">
                <label>数据{{ idx + 1 }} - 说明</label>
                <input v-model="stat.label" placeholder="如：累计培训学员">
              </div>
            </div>
          </div>
          <div class="form-actions">
            <button type="submit" class="btn-primary">保存修改</button>
          </div>
        </form>
      </div>

      <!-- 服务介绍管理 -->
      <div v-if="activeMenu === 'service'" class="panel">
        <div class="panel-header">
          <h3>服务介绍管理</h3>
          <button class="btn-primary" @click="showModal('service')">添加服务</button>
        </div>
        <table class="data-table">
          <thead>
            <tr>
              <th>图片</th>
              <th>标题</th>
              <th>标签</th>
              <th>描述</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in serviceList" :key="item.id">
              <td><img :src="getImageUrl(item.image)" class="thumb"></td>
              <td>{{ item.title }}</td>
              <td>
                <span v-for="tag in item.tags" :key="tag" class="tag">{{ tag }}</span>
              </td>
              <td class="desc-cell">{{ item.description }}</td>
              <td>
                <button @click="editItem('service', item)">编辑</button>
                <button class="btn-danger" @click="deleteItem('service', item.id)">删除</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- 客户案例管理 -->
      <div v-if="activeMenu === 'case'" class="panel">
        <div class="panel-header">
          <h3>客户案例管理</h3>
          <button class="btn-primary" @click="showModal('case')">添加案例</button>
        </div>
        <table class="data-table">
          <thead>
            <tr>
              <th>图片</th>
              <th>标题</th>
              <th>标签</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in caseList" :key="item.id">
              <td><img :src="item.imgUrl" class="thumb"></td>
              <td>{{ item.title }}</td>
              <td><span class="tag">{{ item.tag }}</span></td>
              <td>
                <button @click="editItem('case', item)">编辑</button>
                <button class="btn-danger" @click="deleteItem('case', item.id)">删除</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- 常见问题管理 -->
      <div v-if="activeMenu === 'faq'" class="panel">
        <div class="panel-header">
          <h3>常见问题管理</h3>
          <button class="btn-primary" @click="showModal('faq')">添加问题</button>
        </div>
        <table class="data-table">
          <thead>
            <tr>
              <th>问题</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in faqList" :key="item.id">
              <td>{{ item.question }}</td>
              <td>
                <button @click="editItem('faq', item)">编辑</button>
                <button class="btn-danger" @click="deleteItem('faq', item.id)">删除</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- 荣誉资质管理 -->
      <div v-if="activeMenu === 'honor'" class="panel">
        <div class="panel-header">
          <h3>荣誉资质管理</h3>
          <button class="btn-primary" @click="showModal('honor')">添加资质</button>
        </div>
          <table class="data-table">
          <thead>
            <tr>
              <th>图片</th>
              <th>名称</th>
              <th>证书编号</th>
              <th>简介</th>
              <th>核验渠道</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in honorList" :key="item.id">
              <td><img :src="item.imgUrl" class="thumb"></td>
              <td>{{ item.name }}</td>
              <td>{{ item.certNumber || '-' }}</td>
              <td class="desc-cell" :title="item.description">{{ item.description || '-' }}</td>
              <td class="desc-cell" :title="item.verifyMethod">{{ item.verifyMethod || '-' }}</td>
              <td>
                <button @click="editItem('honor', item)">编辑</button>
                <button class="btn-danger" @click="deleteItem('honor', item.id)">删除</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- 咨询记录管理 -->
      <div v-if="activeMenu === 'submissions'" class="panel">
        <div class="panel-header">
          <h3>咨询记录</h3>
          <div class="header-actions">
            <span class="count">共 {{ submissions.length }} 条</span>
            <button class="btn-refresh" @click="fetchSubmissions">刷新</button>
            <button class="btn-refresh" @click="clearSubmissions">清空</button>
          </div>
        </div>
        <div v-if="submissions.length === 0" class="empty">暂无咨询记录</div>
        <table v-else class="data-table">
          <thead>
            <tr>
              <th>姓名</th>
              <th>电话</th>
              <th>意向班型</th>
              <th>咨询内容</th>
              <th>提交时间</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in submissions" :key="item.id">
              <td>{{ item.name }}</td>
              <td>{{ item.phone }}</td>
              <td>{{ item.courseType || '-' }}</td>
              <td class="message-cell">{{ item.message || '-' }}</td>
              <td>{{ formatDate(item.createdAt) }}</td>
              <td>
                <button class="btn-danger" @click="deleteSubmission(item.id)">删除</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </main>

    <!-- 弹窗 -->
    <div v-if="modalVisible" class="modal" @click.self="modalVisible = false">
      <div class="modal-content">
        <h3>{{ isEditing ? '编辑' : '添加' }}{{ modalTitle }}</h3>
        
        <!-- 案例表单 -->
        <form v-if="modalType === 'case'" @submit.prevent="submitForm('case')">
          <div class="form-group">
            <label>标题</label>
            <input v-model="formData.title" required>
          </div>
          <div class="form-group">
            <label>描述</label>
            <textarea v-model="formData.desc" required></textarea>
          </div>
          <div class="form-group">
            <label>标签</label>
            <input v-model="formData.tag" required>
          </div>
          <div class="form-group">
            <label>图片</label>
            <input type="file" @change="handleFileChange" accept="image/*">
            <img v-if="formData.imgUrl" :src="formData.imgUrl" class="preview-img">
          </div>
          <div class="form-actions">
            <button type="button" @click="modalVisible = false">取消</button>
            <button type="submit" class="btn-primary">保存</button>
          </div>
        </form>

        <!-- FAQ表单 -->
        <form v-if="modalType === 'faq'" @submit.prevent="submitForm('faq')">
          <div class="form-group">
            <label>问题</label>
            <input v-model="formData.question" required>
          </div>
          <div class="form-group">
            <label>答案</label>
            <textarea v-model="formData.answer" required></textarea>
          </div>
          <div class="form-actions">
            <button type="button" @click="modalVisible = false">取消</button>
            <button type="submit" class="btn-primary">保存</button>
          </div>
        </form>

        <!-- 服务表单 -->
        <form v-if="modalType === 'service'" @submit.prevent="submitForm('service')">
          <div class="form-group">
            <label>服务标题</label>
            <input v-model="formData.title" required>
          </div>
          <div class="form-group">
            <label>服务描述</label>
            <textarea v-model="formData.description" required></textarea>
          </div>
          <div class="form-group">
            <label>标签（用逗号分隔）</label>
            <input v-model="tagsInput" placeholder="例如：零基础可学,全科教学">
          </div>
          <div class="form-group">
            <label>图片</label>
            <input type="file" @change="handleFileChange" accept="image/*">
            <img v-if="formData.image" :src="formData.image" class="preview-img">
          </div>
          <div class="form-actions">
            <button type="button" @click="modalVisible = false">取消</button>
            <button type="submit" class="btn-primary">保存</button>
          </div>
        </form>

        <!-- 荣誉表单 -->
        <form v-if="modalType === 'honor'" @submit.prevent="submitForm('honor')">
          <div class="form-group">
            <label>名称</label>
            <input v-model="formData.name" required>
          </div>
          <div class="form-group">
            <label>简介说明</label>
            <textarea v-model="formData.description" placeholder="简单介绍此资质的意义和用途"></textarea>
          </div>
          <div class="form-group">
            <label>证书编号</label>
            <input v-model="formData.certNumber" placeholder="如：闽运管培许可 350102000123号">
          </div>
          <div class="form-group">
            <label>核验渠道</label>
            <textarea v-model="formData.verifyMethod" placeholder="说明在哪里可以核验此证书，如：福建省交通运输厅官网-行政许可公示栏"></textarea>
          </div>
          <div class="form-group">
            <label>图片</label>
            <input type="file" @change="handleFileChange" accept="image/*">
            <img v-if="formData.imgUrl" :src="formData.imgUrl" class="preview-img">
          </div>
          <div class="form-actions">
            <button type="button" @click="modalVisible = false">取消</button>
            <button type="submit" class="btn-primary">保存</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import * as api from '@/api'

export default {
  name: 'Admin',
  data() {
    return {
      activeMenu: 'case',
      menuItems: [
        { key: 'about', label: '企业介绍' },
        { key: 'service', label: '服务介绍' },
        { key: 'case', label: '客户案例' },
        { key: 'faq', label: '常见问题' },
        { key: 'honor', label: '荣誉资质' },
        { key: 'submissions', label: '咨询记录' }
      ],
      aboutData: null,
      serviceList: [],
      caseList: [],
      faqList: [],
      honorList: [],
      submissions: [],
      modalVisible: false,
      modalType: '',
      isEditing: false,
      editingId: null,
      selectedFile: null,
      tagsInput: '',
      aboutFormData: {
        title: '',
        subtitle: '',
        image: '',
        contentTitle: '',
        paragraphs: ['', ''],
        stats: [
          { number: '', label: '' },
          { number: '', label: '' },
          { number: '', label: '' },
          { number: '', label: '' }
        ]
      },
      aboutImageFile: null,
      formData: {
        title: '',
        desc: '',
        tag: '',
        imgUrl: '',
        question: '',
        answer: '',
        name: '',
        description: '',
        certNumber: '',
        verifyMethod: '',
        tags: [],
        image: ''
      }
    }
  },
  computed: {
    modalTitle() {
      const titles = { case: '案例', faq: '问题', honor: '资质', about: '企业介绍', service: '服务' }
      return titles[this.modalType] || ''
    }
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      try {
        const [aboutData, serviceList, caseList, faqList, honorList, submissions] = await Promise.all([
          api.getAbout(),
          api.getServices(),
          api.getCaseList(),
          api.getFaqList(),
          api.getHonorList(),
          api.getSubmissions()
        ])
        this.aboutData = aboutData
        this.serviceList = Array.isArray(serviceList) ? serviceList : []
        this.aboutFormData = {
          title: aboutData.title || '',
          subtitle: aboutData.subtitle || '',
          image: aboutData.image || '',
          contentTitle: aboutData.contentTitle || '',
          paragraphs: aboutData.paragraphs || ['', ''],
          stats: aboutData.stats && aboutData.stats.length > 0 
            ? aboutData.stats 
            : [
                { number: '', label: '' },
                { number: '', label: '' },
                { number: '', label: '' },
                { number: '', label: '' }
              ]
        }
        this.caseList = Array.isArray(caseList) ? caseList : (caseList.data || [])
        this.faqList = Array.isArray(faqList) ? faqList : (faqList.data || [])
        this.honorList = Array.isArray(honorList) ? honorList : (honorList.data || [])
        this.submissions = Array.isArray(submissions) ? submissions : (submissions.data || [])
      } catch (err) {
        console.error('Failed to fetch data:', err)
      }
    },
    formatDate(dateStr) {
      if (!dateStr) return '-'
      const date = new Date(dateStr)
      return date.toLocaleString('zh-CN')
    },
    async fetchSubmissions() {
      try {
        const result = await api.getSubmissions()
        this.submissions = Array.isArray(result) ? result : (result.data || [])
      } catch (err) {
        console.error('Failed to fetch submissions:', err)
      }
    },
    async clearSubmissions() {
      if (!confirm('确定要清空所有咨询记录吗？此操作不可恢复！')) return
      try {
        await api.clearSubmissions()
        this.submissions = []
        alert('已清空所有咨询记录')
      } catch (err) {
        console.error('Failed to clear submissions:', err)
        alert('清空失败')
      }
    },
    async deleteSubmission(id) {
      if (!confirm('确定要删除这条咨询记录吗？')) return
      try {
        await api.deleteSubmission(id)
        await this.fetchData()
      } catch (err) {
        console.error('Delete failed:', err)
        alert('删除失败')
      }
    },
    showModal(type) {
      this.modalType = type
      this.isEditing = false
      this.editingId = null
      this.selectedFile = null
      this.formData = { title: '', desc: '', tag: '', imgUrl: '', question: '', answer: '', name: '', description: '', certNumber: '', verifyMethod: '' }
      this.modalVisible = true
    },
    editItem(type, item) {
      this.modalType = type
      this.isEditing = true
      this.editingId = item.id
      this.formData = { ...item }
      if (type === 'service') {
        this.tagsInput = item.tags ? item.tags.join(',') : ''
      }
      this.modalVisible = true
    },
    getImageUrl(path) {
      if (!path) return ''
      if (path.startsWith('http')) return path
      return path
    },
    handleFileChange(e) {
      const file = e.target.files[0]
      if (file) {
        this.selectedFile = file
        // 直接上传
        this.uploadFileAndSetUrl(file)
      }
    },
    async uploadFileAndSetUrl(file) {
      try {
        const result = await api.uploadImage(file)
        if (result.url) {
          this.formData.imgUrl = result.url
          this.formData.image = result.url
        }
      } catch (err) {
        console.error('Upload failed:', err)
      }
    },
    handleAboutImageChange(e) {
      const file = e.target.files[0]
      if (file) {
        this.aboutImageFile = file
        // 直接上传图片到服务器，获取URL
        this.uploadAboutImage(file)
      }
    },
    async uploadAboutImage(file) {
      try {
        const result = await api.uploadImage(file)
        if (result.url) {
          this.aboutFormData.image = result.url
        }
      } catch (err) {
        console.error('Upload failed:', err)
      }
    },
    async submitAboutForm() {
      try {
        const data = {
          title: this.aboutFormData.title,
          subtitle: this.aboutFormData.subtitle,
          image: this.aboutFormData.image,
          contentTitle: this.aboutFormData.contentTitle,
          paragraphs: this.aboutFormData.paragraphs,
          stats: this.aboutFormData.stats
        }
        
        console.log('Saving about data:', data)
        
        await api.updateAbout(data)
        alert('企业介绍保存成功！')
        await this.fetchData()
      } catch (err) {
        console.error('Failed to save about:', err)
        alert('保存失败: ' + err.message)
      }
    },
    async uploadImage() {
      if (!this.selectedFile) return this.formData.imgUrl
      
      try {
        const result = await api.uploadImage(this.selectedFile)
        return result.url || this.formData.imgUrl
      } catch (err) {
        console.error('Upload failed:', err)
        return this.formData.imgUrl
      }
    },
    async submitForm(type) {
      try {
        const data = { ...this.formData }
        
        // 如果有图片上传
        if (this.selectedFile) {
          const url = await this.uploadImage()
          data.imgUrl = url
          data.image = url
        }

        // 处理服务标签
        if (type === 'service') {
          data.tags = this.tagsInput.split(',').map(t => t.trim()).filter(t => t)
        }

        if (this.isEditing) {
          await api[`update${type.charAt(0).toUpperCase() + type.slice(1)}`](this.editingId, data)
        } else {
          await api[`add${type.charAt(0).toUpperCase() + type.slice(1)}`](data)
        }
        
        this.modalVisible = false
        this.tagsInput = ''
        await this.fetchData()
      } catch (err) {
        console.error('Submit failed:', err)
        alert('操作失败')
      }
    },
    async deleteItem(type, id) {
      if (!confirm('确定要删除吗？')) return
      try {
        await api[`delete${type.charAt(0).toUpperCase() + type.slice(1)}`](id)
        await this.fetchData()
      } catch (err) {
        console.error('Delete failed:', err)
        alert('删除失败')
      }
    }
  }
}
</script>

<style scoped>
.admin-container {
  display: flex;
  min-height: 100vh;
}
.sidebar {
  width: 200px;
  background: var(--primary-color);
  color: white;
  padding: 20px;
}
.sidebar h2 {
  font-size: 18px;
  margin-bottom: 20px;
}
.sidebar nav a {
  display: block;
  padding: 12px 15px;
  color: rgba(255,255,255,0.8);
  text-decoration: none;
  cursor: pointer;
  border-radius: 5px;
  margin-bottom: 5px;
}
.sidebar nav a:hover,
.sidebar nav a.active {
  background: rgba(255,255,255,0.1);
  color: white;
}
.main-content {
  flex: 1;
  padding: 30px;
  background: #f5f7fa;
}
.panel {
  background: white;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.05);
}
.panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #eee;
}
.panel-header h3 {
  color: var(--primary-color);
}
.header-actions {
  display: flex;
  align-items: center;
  gap: 15px;
}
.btn-refresh {
  background: #f5f5f5;
  color: #666;
  border: 1px solid #ddd;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}
.btn-refresh:hover {
  background: #e0e0e0;
}
.btn-primary {
  background: var(--secondary-color);
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
}
.data-table {
  width: 100%;
  border-collapse: collapse;
}
.data-table th,
.data-table td {
  padding: 12px;
  text-align: left;
  border-bottom: 1px solid #eee;
}
.data-table th {
  background: #f9f9f9;
  font-weight: 600;
}
.data-table button {
  padding: 5px 12px;
  margin-right: 5px;
  border: 1px solid #ddd;
  background: white;
  border-radius: 4px;
  cursor: pointer;
}
.data-table .btn-danger {
  color: #e74c3c;
  border-color: #e74c3c;
}
.thumb {
  width: 80px;
  height: 50px;
  object-fit: cover;
  border-radius: 5px;
}
.tag {
  background: var(--light-color);
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 12px;
  color: var(--primary-color);
}
.desc-cell {
  max-width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}
.modal-content {
  background: white;
  padding: 30px;
  border-radius: 10px;
  width: 500px;
  max-height: 80vh;
  overflow-y: auto;
}
.modal-content h3 {
  margin-bottom: 20px;
  color: var(--primary-color);
}
.form-group {
  margin-bottom: 15px;
}
.form-group label {
  display: block;
  margin-bottom: 5px;
  font-weight: 500;
}
.form-group input,
.form-group textarea {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 5px;
}
.form-group textarea {
  min-height: 100px;
}
.preview-img {
  width: 100%;
  max-height: 200px;
  object-fit: contain;
  margin-top: 10px;
}
.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}
.form-actions button {
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
}
.count {
  background: var(--secondary-color);
  color: white;
  padding: 5px 12px;
  border-radius: 20px;
  font-size: 12px;
}
.empty {
  text-align: center;
  padding: 40px;
  color: #999;
}
.message-cell {
  max-width: 300px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.back-home {
  margin-top: auto;
  padding-top: 20px;
  border-top: 1px solid rgba(255,255,255,0.2);
}
.back-home a {
  color: rgba(255,255,255,0.7);
  text-decoration: none;
}
.back-home a:hover {
  color: white;
}

/* 企业介绍表单样式 */
.about-form {
  max-width: 800px;
}
.about-form .form-group {
  margin-bottom: 20px;
}
.about-form .form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 600;
  color: #333;
}
.about-form .form-group input,
.about-form .form-group textarea {
  width: 100%;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
}
.about-form .form-group textarea {
  min-height: 100px;
  resize: vertical;
}
.about-form .preview-img {
  width: 100%;
  max-width: 400px;
  max-height: 250px;
  object-fit: cover;
  margin-top: 10px;
  border-radius: 8px;
}
.stats-section {
  margin-top: 30px;
  padding-top: 20px;
  border-top: 2px solid #eee;
}
.stats-section h4 {
  margin-bottom: 20px;
  color: var(--primary-color);
  font-size: 18px;
}
.stat-item {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
  margin-bottom: 20px;
  padding: 15px;
  background: #f9f9f9;
  border-radius: 8px;
}
.about-form .form-actions {
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #eee;
}
</style>
